import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  ButtonGroup,
  Alert,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import useSubmissionOnEnter from "../hooks/useSubmissionOnEnter";
import GlobalContext from "../context/GlobalContext";

const PasswordRecoveryForm = (props) => {
  const [username, setUsername] = useState("");
  const [error, setError] = useState(null);
  const [show, setShow] = useState(true);
  const [message, setMessage] = useState("");
  const [emptyFields, setEmptyFields] = useState([]);
  const navigate = useNavigate();

  useSubmissionOnEnter("submit");
  const BACKEND_URL = useContext(GlobalContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    const res = await fetch(`${BACKEND_URL}/api/recover-password/${username}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const json = await res.json();

    if (!res.ok) {
      setError(json.message);
      setEmptyFields(json.emptyFields);
    }

    if (res.ok) {
      setError(null);
      setEmptyFields([]);
      setUsername("");

      setMessage(json.message);
    }

    setShow(true);
  };

  return (
    <Container className={"h-100"}>
      <Row className={"h-100"}>
        <Col
          className={"align-self-center offset-xl-3 offset-lg-2"}
          md={12}
          lg={8}
          xl={6}
        >
          {error && show && (
            <Alert
              key={"danger"}
              color={"danger"}
              toggle={() => setShow(false)}
            >
              {error}
            </Alert>
          )}
          {message && show && (
            <Alert
              key={"success"}
              color={"success"}
              toggle={() => setShow(false)}
            >
              {message}
            </Alert>
          )}
          <Card>
            <CardBody>
              <Form>
                <h3>Recover Password</h3>
                <FormGroup
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Label>Email/Username</Label>
                  <Input
                    type="text"
                    placeholder={"Username"}
                    onChange={(e) => setUsername(e.target.value)}
                    value={username}
                    className={
                      emptyFields && emptyFields.includes("username")
                        ? "error"
                        : ""
                    }
                  />
                </FormGroup>

                <FormGroup className={"text-end"}>
                  <ButtonGroup>
                    <Button
                      id={"submit"}
                      color="success"
                      onClick={handleSubmit}
                    >
                      Recover Password
                    </Button>
                  </ButtonGroup>
                </FormGroup>

                <FormGroup className={"text-end"}>
                  <ButtonGroup>
                    <Button
                      size={"sm"}
                      color="secondary"
                      onClick={() => navigate("/register")}
                    >
                      Register
                    </Button>

                    <Button
                      size={"sm"}
                      color="secondary"
                      onClick={() => navigate("/")}
                    >
                      Login
                    </Button>
                  </ButtonGroup>
                </FormGroup>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default PasswordRecoveryForm;
